import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiListBankAccounts,
    apiListBrands,
    apiListCategories,
    apiListCustomers,
    apiListExpenses,
    apiListOrders,
    apiListProducts,
    apiListPurchases,
    apiListReferrals,
    apiListRoles,
    apiListStoreOrders,
    apiListStores,
    apiListVendors,
} from 'Services/UserService'

export const getRoles = createAsyncThunk('user/list/getRoles', async datas => {
    const { data } = await apiListRoles(datas)
    return data
})

export const getStores = createAsyncThunk('user/list/getStores', async () => {
    const { data } = await apiListStores()
    return data
})

export const getBankAccounts = createAsyncThunk('user/list/getBankAccounts', async () => {
    const { data } = await apiListBankAccounts()
    return data
})

export const getBrands = createAsyncThunk('user/list/getBrands', async () => {
    const { data } = await apiListBrands()
    return data
})

export const getCategories = createAsyncThunk('user/list/getCategories', async id => {
    const { data } = await apiListCategories(id)
    return data
})

export const getExpenses = createAsyncThunk('user/list/getExpenses', async id => {
    const { data } = await apiListExpenses(id)
    return data
})

export const getVendors = createAsyncThunk('user/list/getVendors', async datas => {
    const { data } = await apiListVendors(datas)
    return data
})

export const getCustomers = createAsyncThunk('user/list/getCustomers', async datas => {
    const { data } = await apiListCustomers(datas)
    return data
})

export const getReferrals = createAsyncThunk('user/list/getReferrals', async () => {
    const { data } = await apiListReferrals()
    return data
})

export const getProducts = createAsyncThunk('user/list/getProducts', async () => {
    const { data } = await apiListProducts()
    return data
})

export const getPurchases = createAsyncThunk('user/list/getPurchases', async id => {
    if (!id) return []
    const { data } = await apiListPurchases(id)
    return data
})

export const getStoreOrders = createAsyncThunk('user/list/getStoreOrders', async id => {
    const { data } = await apiListStoreOrders(id)
    return data
})

export const getOrders = createAsyncThunk('user/list/getOrders', async id => {
    const { data } = await apiListOrders(id)
    return data
})

export const listSlice = createSlice({
    name: 'user/list',
    initialState: {
        loading: true,
        roles: [],
        stores: [],
        bankAccounts: [],
        brands: [],
        categories: [],
        expenses: [],
        customers: [],
        vendors: [],
        referrals: [],
        products: [],
        purchases: [],
        storeOrders: [],
        orders: [],
    },
    extraReducers: builder => {
        builder
            .addCase(getRoles.fulfilled, (state, { payload }) => {
                state.roles = payload
            })
            .addCase(getRoles.rejected, state => {
                state.roles = []
            })
            .addCase(getStores.fulfilled, (state, { payload }) => {
                state.stores = payload
            })
            .addCase(getStores.rejected, state => {
                state.stores = []
            })
            .addCase(getBankAccounts.fulfilled, (state, { payload }) => {
                state.bankAccounts = payload
            })
            .addCase(getBankAccounts.rejected, state => {
                state.bankAccounts = []
            })
            .addCase(getBrands.fulfilled, (state, { payload }) => {
                state.brands = payload
                state.categories = []
            })
            .addCase(getBrands.rejected, state => {
                state.brands = []
                state.categories = []
            })
            .addCase(getCategories.fulfilled, (state, { payload }) => {
                state.categories = payload
            })
            .addCase(getCategories.rejected, state => {
                state.categories = []
            })
            .addCase(getExpenses.fulfilled, (state, { payload }) => {
                state.expenses = payload
            })
            .addCase(getExpenses.rejected, state => {
                state.expenses = []
            })
            .addCase(getCustomers.fulfilled, (state, { payload }) => {
                state.customers = payload
            })
            .addCase(getCustomers.rejected, state => {
                state.customers = []
            })
            .addCase(getVendors.fulfilled, (state, { payload }) => {
                state.vendors = payload
            })
            .addCase(getVendors.rejected, state => {
                state.vendors = []
            })
            .addCase(getReferrals.fulfilled, (state, { payload }) => {
                state.referrals = payload
            })
            .addCase(getReferrals.rejected, state => {
                state.referrals = []
            })
            .addCase(getProducts.fulfilled, (state, { payload }) => {
                state.products = payload
            })
            .addCase(getProducts.rejected, state => {
                state.products = []
            })
            .addCase(getPurchases.fulfilled, (state, { payload }) => {
                state.purchases = payload
                state.storeOrders = []
                state.orders = []
            })
            .addCase(getPurchases.rejected, state => {
                state.purchases = []
                state.storeOrders = []
                state.orders = []
            })
            .addCase(getStoreOrders.fulfilled, (state, { payload }) => {
                state.purchases = []
                state.storeOrders = payload
                state.orders = []
            })
            .addCase(getStoreOrders.rejected, state => {
                state.purchases = []
                state.storeOrders = []
                state.orders = []
            })
            .addCase(getOrders.fulfilled, (state, { payload }) => {
                state.purchases = []
                state.storeOrders = []
                state.orders = payload
            })
            .addCase(getOrders.rejected, state => {
                state.purchases = []
                state.storeOrders = []
                state.orders = []
            })
    },
})

export default listSlice.reducer
